import axios from "axios";
import { requestHeaderNormalizerInterceptor, authInterceptorFactory } from "@teaming/io-helpers";

const IO_MAILER_NAMESPACE = "mailer";

export default function ioMailerFactory( { config: { baseUri, }, authService, } ) {
	axios.defaults.baseURL = baseUri;
	axios.interceptors.request.use( requestHeaderNormalizerInterceptor );
	axios.interceptors.request.use( authInterceptorFactory( { authService, } ) );

	return {
		namespace: IO_MAILER_NAMESPACE,
		sendWorkstyleReminder( { personId, } ) {
			const url = "/mailer/workstyle-reminder";

			const data = {
				personId,
			};

			return axios( {
				method: "post",
				url,
				data,
			} );
		},
	};
}
